import { Conversation, Listing } from '@app/models'

import { getListingById } from '.'

export const getContextEntity = (listings: Map<number, Listing>, conversation: Conversation) => {
  const entityId = conversation.context?.listingId || conversation.context?.unitId || conversation.context?.projectId
  const listing = getListingById(listings, entityId)
  return listing || null
}